import { IQuestionAnswer, IQuestionAnswerArray } from './../model/question.answer.model';
import { ClaimService } from './claim.service';
import { Injectable } from '@angular/core'
import { BehaviorSubject, Observable } from 'rxjs';
import { IClaimRequest, IClaimResponse } from '../model/claim.model';
import { ISetUpPasswordResetRequest } from '../model/setUpPassword.model';



@Injectable()
export class BehavioralService {

    private questionAnswer : IQuestionAnswer[]= null;
    private userquestionAnswer : ISetUpPasswordResetRequest = null;
    private questionAnswerSubject= new BehaviorSubject<IQuestionAnswer[]> (this.questionAnswer);
    
    questionAnswer$ = this.questionAnswerSubject.asObservable();

    
    private userquestionAnswerSubject= new BehaviorSubject<ISetUpPasswordResetRequest> (this.userquestionAnswer);
    
    userquestionAnswerSubject$ = this.userquestionAnswerSubject.asObservable();



  
    constructor(private claimService:ClaimService) { }
  
    sendQAList(data: IQuestionAnswer[]){
      this.questionAnswerSubject.next(data);
    }

    receiveQAList(): Observable<IQuestionAnswer[]>{
      return this.questionAnswerSubject.asObservable();
    }

    sendQAListResetPassword(data: ISetUpPasswordResetRequest){
      this.userquestionAnswerSubject.next(data);
    }

    receiveQAResetPasswordList(): Observable<ISetUpPasswordResetRequest>{
      return this.userquestionAnswerSubject.asObservable();
    }

    
    private claim : IClaimResponse = null
    private claimSubject= new BehaviorSubject<IClaimResponse> (this.claim);
    
    claim$ = this.claimSubject.asObservable();
  
  
    sendClaimData(data: IClaimResponse){
      this.claimSubject.next(data);
    }

    receiveClaimData(): Observable<IClaimResponse>{
      return this.claimSubject.asObservable();
    }


    private claimRequest : IClaimRequest = null
    private claimRequestSubject= new BehaviorSubject<IClaimRequest> (this.claimRequest);
    
    claimRequest$ = this.claimRequestSubject.asObservable();
  
  
    sendClaimRequestData(data: IClaimRequest){
      this.claimRequestSubject.next(data);
    }

    receiveClaimRequestData(): Observable<IClaimRequest>{
      return this.claimRequestSubject.asObservable();
    }

   

}


